<template>
    <b-table-simple hover responsive>
        <b-thead>
            <b-th> {{$t('customer.users.name')}} </b-th>
            <b-th> {{$t('customer.wizzard.phoneNo')}} </b-th>
            <b-th> {{$t('customer.wizzard.email')}} </b-th>
            <b-th> {{$t('customer.users.task')}} </b-th>
            <b-th> {{$t('customer.list.actions')}} </b-th>
        </b-thead>
        <b-tbody>
            <b-tr v-for="user in data" :key="user.id">
                <b-td> {{user.name}} </b-td>
                <b-td> {{user.phone_no}} </b-td>
                <b-td> {{user.email}} </b-td>
                <b-td> {{user.task}} </b-td>
                <b-td> 
                    <b-icon icon="pencil-square" variant="primary" scale="1.25" shift-v="1.25" aria-hidden="true" title="Düzenle" @click="modalEvent(true, 'edit', user)"></b-icon>
                    <b-icon icon="trash" variant="danger" scale="1.25" shift-v="1.25" aria-hidden="true" title="Sil" @click="modalEvent(true, 'delete', user)"></b-icon>
                </b-td>
            </b-tr>
        </b-tbody>
    </b-table-simple>
</template>
               
<script>
    import Vue from 'vue'
    import VeeValidate from 'vee-validate'
    import i18n from '@/plugins/i18n';

    export default {
        name: "InformationForm",
        data: function(){
            return{
     
            }
        },
        props:{
            data: Array,
            modalEvent: Function
        },
      
    }
</script>

<style lang="css" scoped > 
    @import "../styles/add.min.css"; 
</style>


// WEBPACK FOOTER //
// src/pages/General/Customer/components/Users.vue